import React, { memo } from 'react';

export const prefix = "intent.";

export default memo(({name}) => (
    <React.Fragment>
        { prefix }{ name }
    </React.Fragment>
));